<template>
    <LayoutWrapper :id="id">
        <LayoutPaddingSpace>
            <SequenceTypeBlock multiple />
            <LayoutContainer>
                <LayoutColumn>
                    <SectionTitle>
                        {{ $t('Search.labels.searchParameters') }}
                    </SectionTitle>
                    <SectionBlock>
                        <MultiSubjectLengthField v-if="store.isMultiDbType" />
                        <SubjectLengthField v-else />
                    </SectionBlock>
                </LayoutColumn>
                <LayoutColumn>
                    <SectionTitle>
                        {{ $t('Search.labels.algorithmSettings') }}
                    </SectionTitle>
                    <SectionBlock>
                        <MatchWithGapsField />
                        <EvalueField />
                        <LowComplexRegionField />
                    </SectionBlock>
                </LayoutColumn>
            </LayoutContainer>
            <Collapse v-model="proxyExpand">
                <span slot="label">{{ $t('Search.labels.nonShortSequence') }}</span>
                <LayoutContainer>
                    <LayoutColumn>
                        <SectionBlock>
                            <AlignmentIdentityField />
                            <QueryIdentityField />
                            <QueryCoverageField />
                            <SubjectIdentityField />
                            <SubjectCoverageField />
                        </SectionBlock>
                    </LayoutColumn>
                    <LayoutColumn>
                        <AlgorithmBlock v-if="!store.algorithmSettingsDisabled" />
                    </LayoutColumn>
                </LayoutContainer>
            </Collapse>
            <slot />
        </LayoutPaddingSpace>
        <ResetSection />
    </LayoutWrapper>
</template>

<script>
import ManualPreset from './Manual.preset.vue';
import SequenceTypeBlock from './SequenceType.prefab.vue';

export default {
    components: { SequenceTypeBlock },
    mixins: [ManualPreset],
};
</script>
